/*
 ImgIcon

 Obrazek jako ikona 
  
 historia: 
  PM 2021-09-08 - start
*/

import * as React from 'react';

import { withStyles, WithStyles } from '@material-ui/core/styles';
import { Icon, Tooltip } from '@material-ui/core';

interface ImgIconProps {
    src: string;
    alt: string;
    fontSize?: "inherit" | "medium" | "large" | "small" | "default";
    disablePadding?: boolean
}

class ImgIcon extends React.Component<ImgIconProps & WithStyles<typeof styles>, any> {

    render() {
        const { classes } = this.props;

        return (
            <Tooltip title={this.props.alt}>
                <Icon classes={{ root: classes.iconRoot }} className={classes.icon + (this.props.disablePadding ? '' : ' ' + classes.iconPadding)} fontSize={this.props.fontSize}>
                    <img className={classes.imageIcon} src={this.props.src} alt={this.props.alt} />
                </Icon>
            </Tooltip>
        );
    }
}

const styles = () => ({
    iconRoot: {
        textAlign: 'center' as 'center'
    },
    imageIcon: {
        display: 'flex',
        height: 'inherit',
        width: 'inherit'
    },
    icon: {
        cursor: "pointer"
    },
    iconPadding: {
        padding: "4px 4px",
    }
});

export default withStyles(styles)(ImgIcon);
